import { IEditController } from "../../../../shared/components/edit-table/edit-table";
import { WebForm, IFormField, JsonItem } from "../../../../shared/components/web-form/web-form.objects";
import _ from "lodash";
import { ViewModalTable } from "../../../../shared/components/edit-table/view-modal";
import { DataViewType } from "../../../../shared/components/edit-table/data-viewer";

export class CppReviewModal {
    modalId: string;
    displayName: string;
    editController: IEditController;
    viewTables: ViewModalTable[];

    webForm: WebForm;
    currentItems: any[];
    pickLists: JsonItem[];

    constructor(config: CppReviewModalConfig) {
        this.modalId = config.modalId;
        this.displayName = config.displayName;
        this.webForm = config.webForm;
        this.editController = config.editController;
        this.viewTables = config.viewTables;
    }

    openModal(items: any[], pickLists: JsonItem[] = []): void {
        this.currentItems = items;
        this.pickLists = pickLists;

        this.generateModalHtml();
        this.initializeModalForm();
        this.initializeModal();

        $(`#${this.modalId}`).modal("show");
    }

    showSaving(isSaving: boolean = true): void {
        let modal = $(`#${this.modalId}`);
        let modalContent = modal.find(".modal-content");
        let modalSaving = modal.find(".modal-saving");

        if (isSaving) {
            this.showSaved(false);
            // Hide modal content, show saving display
            modalSaving.removeClass("d-none");
            modalContent.addClass("d-none");
        }
        else {
            modalSaving.addClass("d-none");
            modalContent.removeClass("d-none");
        }
    }

    showSaved(isSaved: boolean = true): void {
        let modal = $(`#${this.modalId}`);
        let modalSaving = modal.find(".modal-saving");
        let savingDisplay = modalSaving.find(".saving-display");
        let savedDisplay = modalSaving.find(".saved-display");

        if (isSaved) {
            // Show 'Saved' text
            savingDisplay.addClass("d-none");
            savedDisplay.removeClass("d-none");
        }
        else {
            // Show 'Saving' text
            savingDisplay.removeClass("d-none");
            savedDisplay.addClass("d-none");
        }
    }

    private generateModalHtml(): void {
        let closeRow = `
            <div class="edit-item-modal-close-row">
                <div class="d-flex justify-content-end">
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true"><i class="fa-solid fa-xmark"></i></span>
                    </button>
                </div>
            </div>
        `;

        let changeHeader = `
            <div class="edit-item-changes-block">
                <div class="expand-changes-btn">
                    <span class="d-inline">
                        <i class="fa-solid fa-chevron-left pr-2 open-changes-icon"></i>
                        View
                        <i class="fa-solid fa-chevron-right pr-2 close-changes-icon"></i>
                    </span>
                </div>
            </div>
        `;

        let selectedRow = ""
        /*selectedRow = `
            <div class="edit-item-subtitle">
                ${this.currentItems.length} Selected
            </div>
        `;*/
        


        let headerRow = `
            <div class="edit-item-modal-header-row">
                <div class="d-flex" style="flex-direction: row-reverse;">
                    ${changeHeader}
                    <div class="col edit-item-overview-block">
                        <div class="edit-item-title mt-2">
                            ${this.displayName}
                        </div>
                        ${selectedRow}
                    </div>
                </div>
            </div>
        `;

        let formSectionBlock = "";

        let verticalTabs = "";
        let formContent = "";
        for (let i = 0; i < this.webForm.formSections.length; i++) {
            let currentSection = this.webForm.formSections[i];
            verticalTabs += `
                <div class="vertical-tab ${i == 0 ? "active" : ""}" data-section-id="${currentSection.sectionId}">
                    <div class="vertical-tab-text">
                        ${currentSection.displayName}
                    </div>
                </div>
            `;

            let formFields = "";
            currentSection.formFields.forEach(field => {
                formFields += field.generateHtml();
            });

            formContent += `
                <div class="form-section-header ${!currentSection.displayName ? "invisible" : ""}" id="${currentSection.sectionId}-section-header">
                    ${currentSection.displayName}
                </div>
                <div class="form-section-fields">
                    ${formFields}
                </div>
            `;
        }

        if (this.webForm.formSections.length <= 1) {
            formSectionBlock = `
                <div class="col-12 form-section">
                    ${formContent}
                </div>
            `
        }
        else {
            formSectionBlock = `
                <div class="form-tabs">
                    <div class="d-flex flex-column vertical-tab-group mb-3">
                        ${verticalTabs}
                    </div>
                </div>
                <div class="form-section">
                    ${formContent}
                </div>
            `;
        }

        let modalBody = `
            <div class="edit-item-modal-body">
                <div class="edit-item-form-container">
                    ${formSectionBlock}
                </div>
                <div class="view-item-modal-container d-none">
                    
                </div>
                <div class="edit-item-error-container d-none">
                    
                </div>
            </div>
        `;

        let modalFooter = `
            <div class="edit-item-modal-footer">
                <button class="butn edit-item-save-btn"><span>Update Status</span></button>
            </div>
        `;


        let html = `
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    ${closeRow}
                    ${headerRow}
                    ${modalBody}
                    ${modalFooter}
                </div>

                <div class="modal-saving d-none">
                    <div class="saving-display d-none">
                        <div class="font-size20 font-weight-500 text-center pb-1">
                            Saving
                        </div>
                        <div class="connect-progress-loader d-flex justify-content-center">
                            <div class="loader"></div>
                        </div>
                    </div>
                    <div class="saved-display d-none">
                        <div class="font-size20 font-weight-500 text-center">
                            Saved!
                        </div>
                    </div>
                </div>
            </div>
        `;

        $(`#${this.modalId}`).empty().html(html);
    }

    private initializeModal(): void {
        let modal = $(`#${this.modalId}`);

        // Save Button
        this.initializeSaveButton();

        // View Change Log Controls
        let changeBtn = modal.find(".edit-item-changes-block");
        let viewContent = modal.find(".view-item-modal-container");
        let formContent = modal.find(".edit-item-form-container");
        changeBtn.on("click", () => {
            changeBtn.toggleClass("expand");
            if (changeBtn.hasClass("expand")) {
                viewContent.removeClass("d-none");
                formContent.addClass("d-none");
            }
            else {
                viewContent.addClass("d-none");
                formContent.removeClass("d-none");
            }
        });

        this.viewTables.forEach(table => table.initialize(this.pickLists));
        this.updateViewTables();
    }

    private initializeSaveButton() {
        let modal = $(`#${this.modalId}`);

        // Save Button
        let saveBtn = modal.find(".edit-item-save-btn");

        saveBtn.on("click", async () => {
            let isValid = this.validateForm();

            if (isValid) {
                this.showSaving();

                let updatedItems = this.getUpdatedItems();

                await this.editController.saveItems(updatedItems, false);

                this.showSaved();

                // Close Modal
                setTimeout(() => {
                    modal.modal("hide");
                }, 1000);
            }
        });
    }

    updateViewTables(): void {
        let modal = $(`#${this.modalId}`);
        let viewContent = modal.find(".view-item-modal-container");

        if (this.currentItems.length > 0) {
            let formObj = this.currentItems[0];
            let html = "";

            this.viewTables.forEach(table => {
                let tableHtml = table.generateTableHtml(formObj);
                html += tableHtml;
            });

            viewContent.empty().html(html);

            this.viewTables.forEach(table => {
                table.dataViewArray.forEach(view => {
                    if (view.propertyType == DataViewType.DocumentUpload) {
                        view.getDocuments(formObj);
                    }
                })
            })
        };
    }

    getUpdatedItems(): any[] {
        let updatedItems = [];

        this.currentItems.forEach(item => {
            let updatedItem = _.cloneDeep(item);

            this.webForm.formSections.forEach(section => {
                section.formFields.forEach(field => {
                    updatedItem = field.updateItem(updatedItem);
                })
            });

            updatedItems.push(updatedItem);
        });

        return updatedItems;
    }

    private validateForm(): boolean {
        let isValid = true;
        let invalidFields: IFormField[] = [];
        this.webForm.formSections.forEach(section => {
            section.formFields.forEach(field => {
                field.resetValidDisplay();
                let isChanged = field.checkChanged();

                let fieldValid = field.checkValid()
                if (!fieldValid) {
                    isValid = false;
                    invalidFields.push(field);
                    field.displayValid(fieldValid);
                }

                if (isChanged && fieldValid) {
                    field.displayValid(fieldValid);
                }
            })
        });

        if (isValid) {
            return true;
        }

        let errorFieldsDisplay = "";
        invalidFields.forEach(field => {
            errorFieldsDisplay += `<li>${field.displayName}</li>`
        });

        let displayTitle = "Issues Found";
        if (invalidFields.length == 1) {
            displayTitle = "Issue Found";
        }

        let errorBlockContent = `
            <div class="error-block">
                <div class="edit-item-error-content">
                    <div class="col-auto">
                        <i class="fa-solid fa-circle-exclamation error-icon"></i>
                    </div>
                    <div class="col">
                        <div class="error-content-title">${invalidFields.length} ${displayTitle}</div>
                        <p class="mb-1">There's an issue with the fields below. Please update these fields before saving:</p>
                        <ul class="ml-4">
                            ${errorFieldsDisplay}
                        </u>
                    </div>
                </div>
                <div class="col-12 pb-3">
                    <button class="edit-item-error-close btn btn-secondary">Hide</button>
                </div>
            </div>
        `;

        let modal = $(`#${this.modalId}`);
        let errorContainer = modal.find(".edit-item-error-container");

        errorContainer.empty().html(errorBlockContent);

        let closeBtn = modal.find(".edit-item-error-close");
        closeBtn.on("click", () => {
            errorContainer.addClass("d-none");
        });

        errorContainer.removeClass("d-none");

        return false;
    }

    private initializeModalForm(): void {
        this.webForm.formSections.forEach(section => {
            section.formFields.forEach(field => {
                field.setOptions(this.pickLists);
                field.initialize();
            })
        });

        this.webForm.formSections.forEach(section => {
            section.formFields.forEach(field => {
                field.prepopulate(this.currentItems);
            })
        })
    }
}

export class CppReviewModalConfig {
    modalId: string; // id of modal target (should already have class "edit-item-modal")
    displayName: string; // Name of item to display when editing
    webForm: WebForm; // Contains form sections/fields
    editController: IEditController; // responsible for saving
    viewTables: ViewModalTable[]; // used to display current form
}